/**
 * Brand configuration — single source of truth for product name and visuals.
 *
 * Alle UI, e-mails, watermerk en page titles gebruiken dit object.
 */

export type Brand = {
  productName: string;          // "Castly"
  productTagline: string;       // korte slogan
  companyName: string;          // bedrijfsnaam (achter het product, in voettekst etc)
  domain: string;               // hoofddomein zonder protocol
  supportEmail: string;
  salesEmail: string;
  primaryColor: string;         // emerald / brand kleur
  accentColor: string;          // coral
  watermarkText: string;        // tekst op FREE plan watermerk
  metaDescription: string;      // SEO/og description
};

export const BRAND: Brand = {
  productName: 'Castly',
  productTagline: 'Narrowcasting voor moderne bedrijven',
  companyName: 'Castly',
  domain: 'castly.nl',
  supportEmail: 'support@castly.nl',
  salesEmail: 'sales@castly.nl',
  primaryColor: '#0d7c66',
  accentColor: '#ff6b4a',
  watermarkText: 'Powered by Castly',
  metaDescription: 'Beheer je narrowcasting schermen vanuit één dashboard. Probeer gratis.',
};
